import React from "react";
import CatalogCollectionPage from "./CatalogCollectionPage";

export default function TrasfoproductPage() {
  return (
    <CatalogCollectionPage
      collectionKey="trasfoproduct"
      eyebrow="Percorsi · TRASFOPRODUCT"
      title="TRASFOPRODUCT 6/12 mesi."
      description="Percorso di trasformazione su 6 o 12 mesi. Contenuti in preparazione."
      testId="trasfoproduct"
    />
  );
}
